module.exports = __webpack_public_path__ + "img/Upstairs_3_thumbnail.430bbc63.webp";